module.exports = __webpack_public_path__ + "img/pkrlhb.8202ea08.png";